/**
 * Copyright (C) 2017-2018 System Clinic Inc. All rights reserved.
 * This file is the property of System Clinic Inc.
 *
 * File: systemRole.js
 * Author: Naoaki Suganuma
 * Update: 2018/3/12
 * Version: 1.0.0
 */

 import * as types from '../constants/ActionTypes';

/**
 * 初期状態
 */
const initialState = {
  roles: null,
  selection: null,
  dirty: false
};

/**
 * system role reducer
 * @param {object} state 
 * @param {string} action 
 */
export default function systemRole(state = initialState, action) {
  switch (action.type) {
    case types.GETTING_SYSTEM_ROLE: {
      return Object.assign({}, state, {
        roles: null,
        selection: null,
        dirty: false
      });
    }
    case types.RECEIVE_GET_SYSTEM_ROLE:
      return Object.assign({}, state, {
        roles: action.roles,
        selection: null,
        dirty: false
      });
    case types.RECEIVE_CREATE_SYSTEM_ROLE: {
      let roles = Object.assign([], state.roles);
      roles.push(action.role);
      return Object.assign({}, state, {
        roles: roles,
        selection: null,
        dirty: false
      });
    }
    case types.RECEIVE_UPDATE_SYSTEM_ROLE: {
      let roles = Object.assign([], state.roles);
      roles.splice(roles.map(function (r) { return r.id; }).indexOf(action.role.id), 1, action.role);
      return Object.assign({}, state, {
        roles: roles,
        selection: null,
        dirty: false
      });
    }
    case types.RECEIVE_DELETE_SYSTEM_ROLE: {
      var roles = state.roles.filter(function (r) { return r.id !== action.roleId; });
      return Object.assign({}, state, {
        roles: roles,
        selection: null,
        dirty: false
      });
    }
    case types.SET_SELECT_SYSTEM_ROLE:
      return Object.assign({}, state, {
        selection: action.role,
        dirty: false
      });
    case types.SET_SYSTEM_ROLE_DIRTY:
      return Object.assign({}, state, {
        dirty: true
      });
    case types.CLEAN_SYSTEM_ROLE:
      return initialState;
    default:
      return state;
  }
}
